import { format } from 'date-fns';
import store from 'general/js/store';
import app from 'general/js/app';
import { receiveScoring } from 'ducks/scoring.reducer';
import { hasValue } from '../general-helpers';
import { getRequestOptions } from './helpers/scoring-loader-helpers';

export const endpointNames = Object.freeze({
    TEE_TIMES: 'teeTimes',
    STATISTICS: 'statistics',
    SUMMARY_REGIONAL: 'summaryRegional',
    SUMMARY_REGIONAL_WO: 'summaryRegionalWO',
    SUMMARY_FINAL: 'summaryFinal',
    SUMMARY_FINAL_WO: 'summaryFinalWO',
    DRAW_REGIONAL: 'drawRegional',
    DRAW_REGIONAL_WO: 'drawRegionalWO',
    DRAW_FINAL: 'drawFinal',
    DRAW_FINAL_WO: 'drawFinalWO',
    LEADERBOARD: 'leaderboard',
    COURSE: 'course',
    LIVE_SCANNER: 'liveScanner',
    PLAYERS: 'players',
    SHOT_TRACKER: 'shotTracker',
    IMGA_SCHEDULE_PLAYERS: 'imgaSchedulePlayers'
});

const defaultConfig = {
    endpointList: []
};

class ScoringLoader {
    constructor(options = {}) {
        this.config = Object.assign(defaultConfig, options.config);
        this.state = {
            endpoints: {}
        };

        this.init();
    }

    init() {
        this.config.endpointList.forEach((endpointConfig) => {
            this.state.endpoints[endpointConfig.name] = {
                ...endpointConfig,
                dependentComponents: 0,
                intervalId: -1,
            };
        });
    }

    

    load = (endpointModel, bearer = '') => {
        fetch(endpointModel.url, getRequestOptions(endpointModel, bearer))
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw new Error(`ScoringLoader fail to load ${endpointModel.url}`);
        }).then((responseJson) => {
            store.dispatch(
                receiveScoring(
                    endpointModel.name,
                    responseJson
                )
            );
        }).catch((error) => {
            const date = format(new Date(), 'DD MMM HH:mm:ss');
            console.log(date, endpointModel.name, error);
        });
    }

    update(bearer = '') {
        Object.values(this.state.endpoints).forEach((endpointModel) => {
            if (endpointModel.dependentComponents > 0) {
                if (endpointModel.intervalId !== -1) return;

                endpointModel.intervalId = setInterval(() => {
                    this.load(endpointModel, bearer);
                }, endpointModel.updateInSeconds * 1000);

                this.load(endpointModel, bearer);
            } else {
                window.clearInterval(endpointModel.intervalId);
                endpointModel.intervalId = -1;
            }
        });
    }

    alreadySubscribed(endpointName) {
        const endpointModel = this.state.endpoints[endpointName];

        if (!hasValue(endpointModel)) {
            return false;
        }

        if (endpointModel.dependentComponents <= 0){
            return false;
        }

        return true;
    }

    subscribe(endpointName, bearer = '') {
        if (!this.state.endpoints[endpointName]) {
            console.log(`We don't have config for: ${endpointName} endpoint.`);
        }

        if (this.state.endpoints[endpointName]) {
            this.state.endpoints[endpointName].dependentComponents += 1;
        }

        this.update(bearer);
    }

    unsubscribe(endpointName) {
        if (this.state.endpoints[endpointName]) {
            this.state.endpoints[endpointName].dependentComponents -= 1;
        }

        this.update();
    }
}

const scoringLoader = new ScoringLoader({ config: app.state.scoringConfig });

export default scoringLoader;
